export default __webpack_public_path__ + "static/media/iconDetailsList.e6f24731.svg";